/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Priority_AirspaceInputs */

const bn_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অগ্রাধিকার আকাশপথ`)
};

const de_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORITÄTSLUFTRAUM`)
};

const el_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΠΡΟΤΕΡΑΙΟΤΗΤΑ εναέριος χώρος`)
};

const en_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORITY AIRSPACE`)
};

const es_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPACIO AÉREO PRIORITARIO`)
};

const fr_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPACE AÉRIEN PRIORITAIRE`)
};

const hi_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिकता हवाई क्षेत्र`)
};

const hu_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KIEMELT LÉGTER`)
};

const id_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RUANG UDARA PRIORITAS`)
};

const it_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPAZIO AEREO PRIORITARIO`)
};

const ja_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`優先空域`)
};

const ko_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우선 공역`)
};

const nl_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORITAIRE LUCHTRUIM`)
};

const pl_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORYTETOWA PRZESTRZEŃ POWIETRZNA`)
};

const pt_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPAÇO AÉREO PRIORITÁRIO`)
};

const ru_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРИОРИТЕТНОЕ ВОЗДУШНОЕ ПРОСТРАНСТВО`)
};

const sv_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRIORITÄRT LUFTRUM`)
};

const tr_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÖNCELİKLİ HAVA SAHASI`)
};

const uk_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРІОРИТЕТНИЙ ПОВІТРЯНИЙ ПРОСТІР`)
};

const vi_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VÙNG TRỜI ƯU TIÊN`)
};

const zh_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先空域`)
};

const zh_hant_cipher_system_priority_airspace = /** @type {(inputs: Cipher_System_Priority_AirspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`優先空域`)
};

/**
* | output |
* | --- |
* | "PRIORITY AIRSPACE" |
*
* @param {Cipher_System_Priority_AirspaceInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_priority_airspace = /** @type {((inputs?: Cipher_System_Priority_AirspaceInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Priority_AirspaceInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_priority_airspace(inputs)
	if (locale === "de") return de_cipher_system_priority_airspace(inputs)
	if (locale === "el") return el_cipher_system_priority_airspace(inputs)
	if (locale === "en") return en_cipher_system_priority_airspace(inputs)
	if (locale === "es") return es_cipher_system_priority_airspace(inputs)
	if (locale === "fr") return fr_cipher_system_priority_airspace(inputs)
	if (locale === "hi") return hi_cipher_system_priority_airspace(inputs)
	if (locale === "hu") return hu_cipher_system_priority_airspace(inputs)
	if (locale === "id") return id_cipher_system_priority_airspace(inputs)
	if (locale === "it") return it_cipher_system_priority_airspace(inputs)
	if (locale === "ja") return ja_cipher_system_priority_airspace(inputs)
	if (locale === "ko") return ko_cipher_system_priority_airspace(inputs)
	if (locale === "nl") return nl_cipher_system_priority_airspace(inputs)
	if (locale === "pl") return pl_cipher_system_priority_airspace(inputs)
	if (locale === "pt") return pt_cipher_system_priority_airspace(inputs)
	if (locale === "ru") return ru_cipher_system_priority_airspace(inputs)
	if (locale === "sv") return sv_cipher_system_priority_airspace(inputs)
	if (locale === "tr") return tr_cipher_system_priority_airspace(inputs)
	if (locale === "uk") return uk_cipher_system_priority_airspace(inputs)
	if (locale === "vi") return vi_cipher_system_priority_airspace(inputs)
	if (locale === "zh") return zh_cipher_system_priority_airspace(inputs)
	return zh_hant_cipher_system_priority_airspace(inputs)
});